// extracted by mini-css-extract-plugin
module.exports = {"container":"Canvas_container__pDNqc","title":"Canvas_title__pQH3u"};